import type { AirbrakeProject } from '@ui/lib/airbrake/config'

// Client-safe constants ONLY. This module is imported by
// instrumentation-client.ts (browser bundle) — it must never import
// @airbrake/node or any other server-only code.
//
// In-code env switch per AGENTS.md "Environment-conditional config":
// NEXT_PUBLIC_VERCEL_ENV is inlined at build time ('production' | 'preview' |
// undefined locally), so the falsy branch covers preview deploys AND local
// prod builds — both report to website-staging, keeping website-prod clean.
//
// NOTE: these constants replace the legacy atm-website project (589628),
// which was wired ONLY via Vercel UI env vars — never in this repo. Those UI
// vars become inert once this deploys (nothing reads NEXT_PUBLIC_AIRBRAKE_*
// anymore) and should be deleted at cutover; 589628 is on the retirement
// ledger (quarantine → delete).
export const AIRBRAKE_PROJECT: AirbrakeProject =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? { projectId: 678199, projectKey: 'c4b5499773a0fee0603346494adc07c9' } // website-prod
    : { projectId: 678200, projectKey: 'f7b386cd0494bcc940af08dcc74e9693' } // website-staging
